import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

/* State and Services */
import { AppState } from '@core/store/app/app.state';
import { AppSelectors } from '@core/store/app/app.selectors';

/* Actions */
import { Logout } from '@core/store/auth/auth.action';

/* Models */
import { TreeNode } from '@core/models/tree-node.model';
import { User } from '@core/models/user.model';

/* Utils */
import { getChildrenNodes, getParentNode } from '@core/utils/common-functions';

@Component({
	selector: 'app-main-header',
	templateUrl: './main-header.component.html',
	styleUrls: ['./main-header.component.scss'],
})
export class MainHeaderComponent implements OnInit, OnDestroy {
	@Input() isHandset$: Observable<boolean>;
	@Input() drawer: any;

	@Select(AppSelectors.activeNode) activeNode$: Observable<TreeNode>;
	@Select(AppState.user) user$: Observable<User>;

	root: TreeNode;
	leaf: TreeNode;
	children: TreeNode[] = [];

	destroy$ = new Subject<void>();

	constructor(private store: Store) {}

	ngOnInit(): void {
		this.activeNode$
			.pipe(
				takeUntil(this.destroy$),
				filter((activeNode) => activeNode !== null),
			)
			.subscribe((activeNode) => {
				this.leaf = activeNode;
				this.children = getChildrenNodes(activeNode);
				this.root = activeNode.parent ? getParentNode(activeNode) : activeNode;
			});
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	onLogout(): void {
		this.store.dispatch(new Logout());
	}
}
